import type { BlockType, BlockPayload } from '../../types'

export function getDefaultPayload(type: BlockType): BlockPayload {
  switch (type) {
    case 'IMAGE':
      return { url: '', alt: '', caption: '' }
    case 'VIDEO':
      return { url: '', width: '560', height: '315', fullWidth: false }
    case 'CONTENT':
      return { html: '' }
    case 'SLIDER':
      return { images: [] }
    case 'FORM':
      return { products: [], btnText: 'สั่งซื้อเลย' }
    case 'COUNTDOWN':
      return {
        expireAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
        title: 'โปรโมชั่นสิ้นสุดใน',
        expiredText: 'หมดเวลาแล้ว!',
        colors: {
          bgGradient: true,
          bgFrom: '#1e1b4b',
          bgTo: '#312e81',
          bgAngle: 135,
          bg: '#1e1b4b',
          digitBg: '#6366f1',
          digitColor: '#ffffff',
          textColor: 'rgba(255,255,255,0.85)',
          iconColor: '#F97316',
        },
      }
    case 'BANK_ACCOUNTS':
      return { title: 'โอนเงินผ่านบัญชี', accounts: [] }
    default:
      return { url: '' }
  }
}
